<template>
    <div>
        <h1>Support Invoicer</h1>
        <p v-show="thinking">Loading...</p>

        <!-- Create Project -->
        <div class="SubForm">
            <div class="row">
                <div class="column">
                    <label>Project Name</label>
                    <input type="text" v-model="newProperty.name">
                    
                    <label>Payment Frequency</label>
                    <select v-model="newProperty.frequency"><option>Yearly</option><option>Monthly</option><option>Quarterly</option></select>
                    
                    <label>Plan Name</label>
                    <select v-model="newProperty.plan_name"><option>Platinum</option><option>Silver</option><option>Gold</option></select>
                </div>
                <div class="column">
                    <label>Plan Commenced</label>
                    <input type="text" v-model="newProperty.plan_commenced" placeholder="YYYY-MM-DD">

                    <label>Yearly Plan Fee</label>
                    <input type="number" step="0.01" v-model="newProperty.plan_fee">

                    <button @click="registerProperty()">Create Project</button>
                </div>
            </div>
        </div>

        <!-- View History -->
        <button @click="loadHistory()">Get History</button>
        
        <!-- Data Table -->
        <table v-if="!thinking">
            <tr>
                <th>Project</th>
                <th>Frequency</th>
                <th>Plan Name</th>
                <th>Commenced</th>
                <th>Base Rate</th>
                <th>Next Due</th>
                <th>Amount Due</th>
                <th>Actions</th>
            </tr>
            <tr v-for="i in invoices" :key="i.id">
                <td>{{i.name}}</td>
                <td>{{i.frequency}}</td>
                <td>{{i.plan_name}}</td>
                <td>{{i.plan_commenced | date}}</td>
                <td>$ {{i.plan_fee.toFixed(2)}}</td>
                <td><b>{{i.next_due_date | date}}</b></td>
                <td><b>$ {{i.next_due_fee.toFixed(2)}}</b></td>
                <td>
                    <button v-if="i.invoiced==0" @click="markInvoiced(i.id)">Mark Invoiced</button>
                    <p v-else>Already Invoiced</p>
                </td>
            </tr>
        </table>
    </div>
</template>


<script>
    // Import Helpers
    import {CallApi} from '../Utilities.js'

    function NewProperty() {
        return {
	        name:"",
	        frequency: "",
            plan_name: "",
            plan_commenced: "",
            plan_fee: 0
        }
    }

    // Module Code
    export default {
        data:  function () {
            return {
                thinking:true,
                invoices: [],
                newProperty:NewProperty()
            }
        },
        methods: {
            getData: async function() {
                this.thinking = true
                const apiResult = await CallApi("GET", "/supportinvoicer/")
                this.invoices = apiResult.fees
                this.thinking = false
            },
            loadHistory : async function() {
                this.thinking = true
                const apiResult = await CallApi("GET", "/supportinvoicer/history")
                this.invoices = apiResult.fees
                this.thinking = false
            },
            markInvoiced: async function(id) {
                this.thinking = true
                await CallApi("POST", "/supportinvoicer/" + id, {})
                const apiResult = await CallApi("GET", "/supportinvoicer/")
                this.invoices = apiResult.fees
                this.thinking = false
            },
            registerProperty: async function() {
                this.thinking = true
                await CallApi('POST', "/supportinvoicer/", this.newProperty)
                this.getData()
                this.newProperty = NewProperty()
                this.thinking = false
            },
        },
        mounted: function() {
            this.getData()
        }
    }
</script>

